import React from 'react';
import { Row, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { removeAccents } from '../../../components/utils/ParseUtils';
import I18n from 'i18n-react';
import './TextField.css';
import { Button } from 'react-bootstrap/lib/InputGroup';
import TooltipBottom from '../../tooltip/ToolTip';

const propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  required: PropTypes.bool,
  isUpperCase: PropTypes.bool,
  errorMessage: PropTypes.string,
  placeholder: PropTypes.string,
  maxLength: PropTypes.number,
  changeValue: PropTypes.func.isRequired,
  trim: PropTypes.bool,
  value: PropTypes.string,
  isFieldsEnabled: PropTypes.bool,
  isName: PropTypes.bool,
  isRenderIconEdit: PropTypes.bool
};

const defaultProps = {
  label: '',
  required: false,
  isUpperCase: false,
  errorMessage: '',
  placeholder: '',
  maxLength: 999,
  trim: false,
  value: null,
  isFieldsEnabled: true,
  isName: false,
  isRenderIconEdit: false
};

class TextField extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isValidState: true,
      value: props.value ? props.value : '',
      isEditing: false,
      disabled: true
    };
  }

  handleEditClick = () => {
    this.setState({ isEditing: true });
  };

  componentWillReceiveProps(props) {
    if (props.value !== null) {
      this.setState({
        value: props.value
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isFieldsEnabled !== this.props.isFieldsEnabled) {
      this.setState({ isEditing: this.props.isFieldsEnabled });
    }
  }

  onChangeCursor = event => {
    const { selectionStart, selectionEnd, value } = event.target;
    this.removeInvalidCharacters(value, newValue => {
      this.setState({ value: newValue }, () => {
        if (this.input && this.input.setSelectionRange) {
          this.input.setSelectionRange(selectionStart, selectionEnd);
        }
      });
    });
  };

  renderTooltipBottom() {
    if (this.props.isRenderIconEdit) {
      return (
        <div className={this.props.isName ? 'ToolTip_FirstName' : 'ToolTip_LastName' }>
          <Col xs={12} md={3} className="PassengerInfo__sufix">
            <TooltipBottom tooltipMessage={this.props.isName ? 
                I18n.translate('components.passengerInfo.name.tooltip').toString() : 
                I18n.translate('components.passengerInfo.lastName.tooltip').toString()
              }/>
          </Col>
        </div>
      );
    }
  }

  renderIconEdit() {
    if (this.props.isRenderIconEdit && !this.state.isEditing) {
      return (
        <Button type="button" className="icon-button" onClick={this.handleEditClick}>
          <svg className="icon" viewBox="0 0 1024 1024" width="20" height="20">
            <path
              transform="scale(1, -1) translate(0, -1024)"
              d="M884 638.667l-78-78-160 160 78 78q12 12 30 12t30-12l100-100q12-12 12-30t-12-30zM128 202.667l472 472 160-160-472-472h-160v160z"
            />
          </svg>
        </Button>
      );
    }
  }

  renderLabel() {
    let label = '';

    if (this.props.label) {
      label = (
        <Row className="Field__label">
          <Col id={`${this.props.id}_textFieldLabel`} xs={12}>
            <span className={this.state.isValidState ? 'Field__validField' : 'Field__invalidField'}>
              {I18n.translate(this.props.label)}
            </span>
            {this.props.required ? (
              <span id="requiredIconId" className="Field__required">
                {' '}
                •
                {this.renderTooltipBottom()}
              </span>
            ) : (
              ''
            )}
          </Col>
        </Row>
      );
    }

    return label;
  }

  renderField() {
    return (
      <div className="form-group">
        <Row>
          <Col xs={12}>
            <div className="input-with-icon">
              <input
                type="text"
                id={`${this.props.id}_textFieldId`}
                onBlur={event => {
                  this.validateField(event.target.value);
                  this.onBlurFieldToIco(event);
                }}
                onChange={this.onChangeCursor}
                placeholder={I18n.translate(this.props.placeholder)}
                maxLength={this.props.maxLength}
                className={`data-hj-whitelist Field__input ${
                  this.state.isValidState ? 'Field__validInput' : 'Field__invalidInput'
                }`}
                value={this.state.value}
                ref={ref => (this.input = ref)}
                style={this.props.styleEncode}
                disabled={!this.state.isEditing && this.props.isRenderIconEdit}
              />
              {this.renderIconEdit()}
            </div>
          </Col>
        </Row>
      </div>
    );
  }

  onBlurFieldToIco(event) {
    if (this.props.styleFieldIdentifier && this.props.callCenterMode)
      return this.props.onBlurFieldToIco(
        this.props.styleFieldIdentifier,
        this.props.iconIdentifier,
        event
      );
  }

  renderValidationMessage() {
    let message = <Row id={`${this.props.id}_textFieldFooter`} className="Field__message" />;

    if (!this.state.isValidState) {
      message = (
        <Row className="Field__message error">
          <Col id={`${this.props.id}_textFieldFooter`} xs={12}>
            <span className="Field__invalidField">{I18n.translate(this.props.errorMessage)}</span>
          </Col>
        </Row>
      );
    }

    return message;
  }

  validate = () => {
    return this.validateField(this.state.value);
  };

  validateField(value) {
    const isValid = !this.props.required || (this.props.required && value.length > 0);

    this.setState({
      isValidState: isValid,
      value: value
    });
    this.props.changeValue(value);

    return isValid;
  }

  removeInvalidCharacters(value, callback) {
    let newValue = removeAccents(value);

    if (this.props.isUpperCase) {
      newValue = newValue.toUpperCase();
    }

    if (this.props.trim) {
      newValue = newValue.replace(/\s/g, '');
    }

    this.setState({ 
      value: newValue 
    }, () => {
      if (callback) callback(newValue);
    });
  }

  render() {
    return (
      <div id={this.props.id} className="TextField Field">
        {this.renderLabel()}
        {this.renderField()}
        {this.renderValidationMessage()}
      </div>
    );
  }
}

TextField.propTypes = propTypes;
TextField.defaultProps = defaultProps;

export default TextField;



// WEBPACK FOOTER //
// ./src/components/passengerInfo/textField/TextField.jsx